import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import { setAnswer } from '../actions/questions';
import { triggerTransition } from '@uirouter/redux';
import { getXssFilter } from '../../../helpers/helpers';
import Button from '@s/Button';

import KioskHeaderContainer from '../../kiosk/containers/KioskHeaderContainer';
import KioskBodyContainer from '../../kiosk/containers/KioskBodyContainer';
import Translation from "../../../../shared/Translation";

class KioskWaiverView extends Component {
    render() {
        if (this.props.question &&
            this.props.question.waiver_text &&
            this.props.question.resource_id &&
            this.props.question.answer_resource_id &&
            this.props.question.answer_resource_type) {
            return(
                <div className="kiosk__checkout">
                    <KioskHeaderContainer />
                    <KioskBodyContainer>
                        <div className="kiosk__body--waiver" dangerouslySetInnerHTML={{__html: getXssFilter().process(this.props.question.waiver_text)}}/>
                    </KioskBodyContainer>
                    <div className="input__checkbox kiosk__waiver__checkbox">
                        <div className="kiosk__waiver__target" onClick={this.acceptWaiver}>
                            <div className="input__checkbox__input">
                                <input type="checkbox" id={"waiver_id_"+this.props.id}
                                    name="kiosk_waiver"
                                    // checked={this.props.waiverChecked}
                                    disabled
                                />
                                <i className={`input__checkbox__mask ${this.props.question.answer === true ? 'icon-checkbox_on' : 'icon-checkbox_off'}`}  aria-hidden="true"></i>
                            </div>
                            <label htmlFor={"waiver_id_"+this.props.id} className="input__checkbox__label">{this.props.question.options[0]}</label>
                        </div>
                        <div className="kiosk__waiver__close">
                            <Button
                                onClick={ this.exitWaiver }
                                className="kiosk-footer__button--secondary"
                            >
                                <i className="button-secondary--icon icon-close" aria-hidden="true"></i>
                                <Translation>{'checkout__close'}</Translation>
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    acceptWaiver = () => {
        this.props.setAnswer(
            this.props.question.resource_id,
            this.props.question.answer_resource_id,
            this.props.question.answer_resource_type,
            true
        );
        this.exitWaiver();
    }

    exitWaiver = () => {
        this.props.triggerTransition("checkout", {token: this.props.token});
    }
}

const mapStateToProps = state => {
    return {
        token: state.reservation.token,
        headerImage: state.ui.uiConfig.images.checkoutHeader,
        eventName: state.event.name,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setAnswer,
        triggerTransition,
    }, dispatch);
}

KioskWaiverView.defaultProps = {
    waiverChecked: false
}

KioskWaiverView.propTypes = {
    question: PropTypes.object.isRequired,
    // waiverChecked: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(KioskWaiverView)
